// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchForm_root__IMZFB","icon":"SearchForm_icon__gW2_o","input":"SearchForm_input__R_wH2","button":"SearchForm_button__psdzR"};